import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import LandingPage from './pages/LandingPage';
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import MenuOnSitePage from './pages/MenuOnSitePage';
import ReservationPage from './pages/ReservationPage';
import AdminPage from './pages/AdminPage';
import AnalyticsPage from './pages/AnalyticsPage';
import RevenueDashboardPage from './pages/RevenueDashboardPage';
import FixedChargesPage from './pages/FixedChargesPage';
import ReviewsPage from './pages/ReviewsPage';
import RevenueUploadPage from './pages/RevenueUploadPage';
import DepensePage from './pages/DepensePage';
import BlockedSlotsPage from './pages/BlockedSlotsPage';
import RamadanMenuAdminPage from './pages/RamadanMenuAdminPage';
import { AdminRouteGuard } from './components/AdminRouteGuard';
import { trackPageView, initGA } from './utils/analytics';
import { HOME_ROUTE_KEY } from './utils/sessionStorageKeys';
import './App.css';

function AppContent() {
  const { language } = useLanguage();
  const location = useLocation();

  // Mémoriser la page d'accueil d'origine pour le tracking (utilisateurs / vs /onSite)
  React.useEffect(() => {
    const path = location.pathname;
    if ((path === '/' || path === '/onSite') && !sessionStorage.getItem(HOME_ROUTE_KEY)) {
      sessionStorage.setItem(HOME_ROUTE_KEY, path);
    }
  }, [location.pathname]);
  
  React.useEffect(() => {
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  // Initialiser Google Analytics au chargement
  React.useEffect(() => {
    initGA();
  }, []);

  // Tracker les changements de route
  React.useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/onSite" element={<LandingPage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/menuOnSite" element={<MenuOnSitePage />} />
        <Route path="/reservation" element={<ReservationPage />} />
        <Route path="/admin" element={<AdminRouteGuard><AdminPage /></AdminRouteGuard>} />
        <Route path="/admin/reservations" element={<AdminRouteGuard><AdminPage /></AdminRouteGuard>} />
        <Route path="/admin/revenue" element={<AdminRouteGuard><RevenueDashboardPage /></AdminRouteGuard>} />
        <Route path="/admin/analytics" element={<AdminRouteGuard><AnalyticsPage /></AdminRouteGuard>} />
        <Route path="/admin/fixed-charges" element={<AdminRouteGuard><FixedChargesPage /></AdminRouteGuard>} />
        <Route path="/admin/reviews" element={<AdminRouteGuard><ReviewsPage /></AdminRouteGuard>} />
        <Route path="/admin/revenue-upload" element={<AdminRouteGuard><RevenueUploadPage /></AdminRouteGuard>} />
        <Route path="/admin/depense" element={<AdminRouteGuard><DepensePage /></AdminRouteGuard>} />
        <Route path="/admin/blocked-slots" element={<AdminRouteGuard><BlockedSlotsPage /></AdminRouteGuard>} />
        <Route path="/admin/ramadan-menu" element={<AdminRouteGuard><RamadanMenuAdminPage /></AdminRouteGuard>} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <Router>
          <AppContent />
        </Router>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;


